import { ClassValue } from 'clsx';
import { View } from '@shared/components/View';
import classNames from './Separator.module.css';

export interface SeparatorProps {
  // If set, the separator will be a thin vertical line instead of a thin
  // horizontal line. Default is false.
  vertical?: boolean;

  // Purely visual — the boundary is already conveyed by an adjacent label,
  // heading or layout, so assistive tech should skip the line. Without this the
  // separator is announced as a content boundary.
  decorative?: boolean;

  // Set `--separator-color` from a companion CSS module to recolor the line.
  // Defaults to the theme's inactive foreground.
  className?: ClassValue;
}

export function Separator({ vertical = false, decorative = false, className }: SeparatorProps) {
  const orientation = vertical ? 'vertical' : 'horizontal';

  return (
    <View
      role={decorative ? undefined : 'separator'}
      aria-orientation={orientation}
      className={[classNames.separator, className]}
    />
  );
}
